import { API_CONFIG } from '@/services/api/api.config';

export const URL_VIDEO_EXPLICATIVO = 'https://senciyo.pe/videos';

export function construirUrlSuscripcion(
  empresaId?: string | null,
  opciones?: { view?: string; sku?: string; planSku?: string; mode?: string }
): string {
  const base = `${API_CONFIG.INFO_CONTASIS_URL}/senciyo-suscripcion`;
  const params = new URLSearchParams();
  if (opciones?.view) params.set('view', opciones.view);
  if (opciones?.mode) params.set('mode', opciones.mode);
  if (empresaId) params.set('empresaId', empresaId);
  if (opciones?.sku) params.set('sku', opciones.sku);
  if (opciones?.planSku) params.set('planSku', opciones.planSku);
  const query = params.toString();
  return query ? `${base}?${query}` : base;
}

export function construirUrlCambiarTarjeta(empresaId: string): string {
  return construirUrlSuscripcion(empresaId, { view: 'actualizar', mode: 'cambiar-tarjeta' });
}
